import React, { useEffect } from 'react';
import { Modal } from '@gerdau/hefesto';
import { ChooseNewOrReviewContent, ModalOverlay } from './styles';
import { useHistory } from 'react-router-dom';
import { loadOrderVersionReview } from '../../store/ducks/fabrication-contracts/actions';
import { getFabricationPurchaseStateFromFabricationOrder } from '../../utils/purchaseHelpers';
import { updateFabricationPurchaseOrderSettings } from '../../store/ducks/fabrication-purchase-order/actions';
import { useDispatch, useSelector } from 'react-redux';
import { IFabricationOrder } from '../../store/ducks/fabrication-orders/types';
import { FabricationOrdersService } from '../../services/FabricationOrders';
import { ILastOrderDetails } from '../../store/ducks/fabrication-contracts/types';

export interface ChooseBetweenNewOrReviewOrderModalProps {
  onCloseModal: () => void;
  order: ILastOrderDetails;
  onChooseCreate: () => void;
  from: string;
  payload?: IFabricationOrder;
  revisionEnabled?: (orderId: number) => {
    enableRevision: boolean;
    tooltipDisabledRevision: string;
  };
}

export const ChooseBetweenNewOrReviewOrderModal = ({
  onCloseModal,
  order,
  onChooseCreate,
  from,
  payload,
  revisionEnabled
}: ChooseBetweenNewOrReviewOrderModalProps) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'visible';
    };
  }, []);

  const history = useHistory();
  const dispatch = useDispatch();

  function createNewOrder() {
    onCloseModal();
    onChooseCreate();
  }

  const loadFabricationOrderFromId = async (): Promise<IFabricationOrder> => {
    const fabricationOrdersService = new FabricationOrdersService();
    return fabricationOrdersService.getFabricationOrderFromId(order.id);
  };

  const reviewOrder = async () => {
    const gerdauOrderNumber = order.gerdauOrderNumber;
    const contractNumber = order.contractNumber;
    if (contractNumber && gerdauOrderNumber !== undefined) {
      dispatch(loadOrderVersionReview(contractNumber, gerdauOrderNumber, true));

      const fabricationOrder = await loadFabricationOrderFromId();
      const fabricationPurchaseOrderState =
        getFabricationPurchaseStateFromFabricationOrder(fabricationOrder);

      onCloseModal();

      history.push('/purchase/fabrication/fabrication-review-order', {
        from,
        payload
      });

      dispatch(
        updateFabricationPurchaseOrderSettings({
          ...fabricationPurchaseOrderState,
          constructionIdentification: {
            ...fabricationPurchaseOrderState.constructionIdentification,
            orderNumber: ''
          }
        })
      );
    }
  };

  return (
    <ModalOverlay>
      <Modal
        onClose={onCloseModal}
        title="Criar um novo pedido ou revisá-lo "
        modalSize="sm"
        buttons={{
          right: {
            name: 'button-close-blocked-emitter2',
            children: 'Criar novo pedido',
            onClick: createNewOrder,
            type: 'submit'
          },
          left: {
            name: 'button-close-blocked-emitter',
            children: 'Solicitar revisão',
            onClick: reviewOrder,
            type: 'button',
            disabled: revisionEnabled
              ? !revisionEnabled(order.id)?.enableRevision
              : false
          }
        }}
      >
        <ChooseNewOrReviewContent>
          <div>
            Deseja criar um novo pedido a partir do{' '}
            <strong>{order.formattedOrderCode || order.orderNumber}</strong> ou
            solicitar uma nova revisão?
            <br />
            <strong>Atenção: Um novo pedido não será uma revisão.</strong>
          </div>
        </ChooseNewOrReviewContent>
      </Modal>
    </ModalOverlay>
  );
};
